export default "__VITE_ASSET__9ee2b6f1__"